import i18n from 'live/services/i18n'
import locale from 'live/init/global-locale'

import ptBr from './ptBr'
import enUs from './enUs'

const localeFiles = {
    pt_br: ptBr,
    en_us: enUs
}

i18n.add(localeFiles[locale])
